import reusables from '@styles/theme/reusables';
import theme from '@styles/theme';
const PDF_HEADING_HEIGHT = '108px';
const PDF_DESKTOP_MEDIA = '@media (min-width: 1026px)';
const modalStyles = {
  areaModal: (active: boolean, overlayAddSx?: Record<string, unknown>, fullScreen?: boolean, borderLess?: boolean, pdfLayout?: boolean) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    bg: 'RGBA(0,0,0,0.4)',
    border: 'none',
    zIndex: theme.zIndex.modalUp,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: active ? 1 : 0,
    visibility: active ? 'visible' : 'hidden',
    cursor: 'unset',
    ...reusables.mainTransition('opacity, visibility'),
    ...overlayAddSx,
    ...(pdfLayout ? {
      padding: 0,
      transitionProperty: 'opacity, visibility',
      transitionDuration: theme.transitions.time.normal,
      transitionTimingFunction: theme.transitions.animation.atomCurve,
      [PDF_DESKTOP_MEDIA]: {
        padding: '40px 0'
      },
      '@media (prefers-reduced-motion: reduce)': {
        transition: 'none'
      }
    } : {
      padding: borderLess ? '0' : fullScreen ? ['0', '0', '40px 0 40px 0'] : '0'
    })
  }),
  modal: (addSx?: Record<string, unknown>, fullScreen?: boolean, borderLess?: boolean, pdfLayout?: boolean) => ({
    bg: theme.rawColors.neutralWhite,
    boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    ...addSx,
    ...(pdfLayout ? {
      width: '100%',
      height: 'auto',
      maxWidth: '100%',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      padding: 0,
      outline: 'none',
      [PDF_DESKTOP_MEDIA]: {
        width: '100%',
        height: '100%',
        maxWidth: '1280px'
      }
    } : {
      width: fullScreen ? '100%' : 'auto',
      height: fullScreen ? '100%' : 'auto',
      maxWidth: borderLess ? '100%' : fullScreen ? '1280px' : 'auto',
      overflowY: 'hidden',
      display: fullScreen ? 'flex' : 'block',
      flexDirection: 'column',
      padding: fullScreen ? '0' : ''
    })
  }),
  modalHeading: (isLoginVariant: boolean, isFullScreen: boolean, pdfLayout?: boolean) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexShrink: 0,
    ...(pdfLayout ? {
      minHeight: PDF_HEADING_HEIGHT,
      height: PDF_HEADING_HEIGHT,
      padding: '0 24px',
      borderBottom: `1px solid ${theme.rawColors.lightGrey300}`,
      [PDF_DESKTOP_MEDIA]: {
        height: 'auto'
      }
    } : {
      flexDirection: isLoginVariant && 'column-reverse',
      height: isLoginVariant ? 'auto' : '108px',
      padding: isLoginVariant ? '0' : isFullScreen ? ['0 16px', '0 16x', '0 40px'] : '0 24px',
      borderBottom: !isLoginVariant ? `1px solid ${theme.rawColors.lightGrey300}` : 'none'
    })
  }),
  modalContent: (addContentSx?: Record<string, unknown>, pdfLayout?: boolean) => pdfLayout ? {
    flex: 'none',
    overflow: 'hidden',
    minHeight: 0,
    width: '100%',
    height: `calc(100vh - ${PDF_HEADING_HEIGHT})`,
    maxHeight: `calc(100vh - ${PDF_HEADING_HEIGHT})`,
    [PDF_DESKTOP_MEDIA]: {
      flex: 1,
      width: 'auto',
      height: 'auto',
      maxHeight: 'none'
    },
    ...addContentSx
  } : {
    ...addContentSx,
    flex: 1,
    overflow: 'hidden'
  },
  pdfHeadingTitle: {
    margin: 0,
    fontFamily: theme.fonts.uniformMedium,
    fontSize: theme.fontSizes.h4,
    fontWeight: theme.fontWeights.medium,
    lineHeight: '140%',
    letterSpacing: theme.letterSpacings.smallCaps,
    color: theme.rawColors.darkGrey700,
    textAlign: 'left'
  },
  pdfCloseButton: {
    marginLeft: '16px',
    flexShrink: 0,
    button: {
      padding: '8px',
      height: 'auto',
      background: 'transparent',
      border: 'none'
    }
  },
  pdfFrame: {
    display: 'block',
    width: '100%',
    height: `calc(100vh - ${PDF_HEADING_HEIGHT})`,
    maxHeight: `calc(100vh - ${PDF_HEADING_HEIGHT})`,
    minHeight: 0,
    border: 'none',
    [PDF_DESKTOP_MEDIA]: {
      height: '100%',
      maxHeight: 'none',
      minHeight: '60vh'
    }
  },
  headingWrapper: {
    textAlign: 'center',
    pt: ['40px', '40px', '40px', '40px', '60px', '67px']
  },
  closeButtonWrapper: {
    m: ['12px 12px 0 auto', '12px 12px 0 auto', '12px 12px 0 auto', '12px 12px 0 auto', '20px 40px 0 auto'],
    display: 'flex',
    alignItems: 'right'
  }
};
export default modalStyles;